import routes from '@/constants/routes';
// import trainsNavigation from '@/config/trains-navigation';

export default [
  {
    text: 'header.about',
    link: routes.ABOUT,
  },
  // {
  //   text: 'header.trains',
  //   link: routes.WIKI,
  // },
  {
    text: 'header.trains',
    link: routes.WIKI,
  },
  // {
  //   text: 'header.getApp',
  //   link: routes.APP,
  // },
  {
    text: 'header.help',
    link: routes.HELP_ON_BOARD,
  },
  {
    text: 'header.contacts',
    link: routes.CONTACT,
  },
  // {
  //   text: 'header.faq',
  //   link: routes.FAQ,
  // },
];
